<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  font-size: 14px;
}

#app {
  width: 100%;
  min-height: 100vh;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #1a73e8;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #0d47a1;
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}
</style>